import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import blogImg from "../../assets/img/avoConsulteBlogImg.png";
import { articleUrl, formatArticleDate } from "./articleHelpers";

export default function BlogsCardSideBar(props) {
  const Lng = localStorage.getItem("lang");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const url = articleUrl(props.blog, Lng);

  function open(e) {
    e.preventDefault();
    navigate(url);
    window.scrollTo(0, 0);
  }

  return (
    <li className="avc-latest__item">
      <a href={url} onClick={open} className="avc-latest__thumb" tabIndex={-1}>
        <img
          src={props.blog?.image || blogImg}
          onError={(e) => {
            e.target.src = blogImg;
          }}
          alt=""
          width="76"
          height="56"
          loading="lazy"
          decoding="async"
        />
      </a>
      <div className="avc-latest__info">
        <a href={url} onClick={open} className="avc-latest__title">
          {props.blog.title || t("blog_is_not_available")}
        </a>
        <time dateTime={props.blog?.createdAt}>
          {formatArticleDate(props.blog?.createdAt, Lng)}
        </time>
      </div>
    </li>
  );
}
